import React from 'react';
import { AnimatedSkeletonLoader } from '@/components/animated-skeleton-loader';
import { createStyles } from '@/contexts/theme-context';
import { View, ViewStyle } from 'react-native';

interface NavItemSkeletonProps {
  style?: ViewStyle;
}

export const NavItemSkeleton: React.FC<NavItemSkeletonProps> = ({ style }) => {
  const [styles] = useStyles();
  return (
    <View style={[styles.navItem, style]}>
      <AnimatedSkeletonLoader
        borderRadius={4}
        height={24}
        style={styles.skeletonIcon}
        width={24}
      />
      <AnimatedSkeletonLoader
        borderRadius={4}
        height={14}
        style={styles.skeletonText}
        width={71}
      />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  navItem: {
    alignItems: 'center',
    borderRadius: theme.sk.radii.radiusSmall,
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceSMedium,
    paddingHorizontal: theme.sk.spacing.spaceSmall,
    paddingVertical: theme.sk.spacing.spaceXsmall,
  },
  skeletonIcon: {
    marginTop: 0,
  },
  skeletonText: {
    marginTop: 0,
  },
}));
